import { Box, Typography } from "@mui/material";
import SvgToIcon from "../../icons/SvgToIcon";
import {
  jiraPriorities,
  severities,
} from "../../scenes/stack/environment/icons/iconExport";

const ImgOption = ({ label, type }) => {
  const severityIcons = {
    High: severities.HighSeverityIcon,
    Medium: severities.MediumSeverityIcon,
    Low: severities.LowSeverityIcon,
    Critical: severities.CriticalSeverityIcon,
  };
  const jiraIcons = {
    Lowest: jiraPriorities.LowestIcon,
    Low: jiraPriorities.LowIcon,
    Medium: jiraPriorities.MediumIcon,
    High: jiraPriorities.HighIcon,
    Highest: jiraPriorities.HighestIcon,
    Triage: jiraPriorities.TriageIcon,
  };

  const entityRiskIcons = {
    Critical: severities.CriticalSeverityIcon,
    High: severities.HighSeverityIcon,
    Medium: severities.MediumSeverityIcon,
    Low: severities.LowSeverityIcon,
    Minimal: severities.MinimalSeverityIcon,
  };

  const tenantRiskIcons = {
    Critical: severities.CriticalSeverityIcon,
    High: severities.HighSeverityIcon,
    Medium: severities.MediumSeverityIcon,
    Low: severities.LowSeverityIcon,
  };

  let Icon;
  switch (type) {
    case "jira":
      Icon = jiraIcons[label];
      break;
    case "severity":
      Icon = severityIcons[label];
      break;
    case "entityRisk":
      Icon = entityRiskIcons[label];
      break;
    case "tenantRisk":
      Icon = tenantRiskIcons[label];
      break;
    default:
      break;
  }

  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      alignItems={"center"}
      justifyContent={"space-around"}
    >
      <SvgToIcon
        IconLogo={Icon}
        style={{ width: "16px", color: "transparent" }}
      />
      <Typography
        variant="caption"
        style={{ textTransform: "none", fontSize: "12px", paddingLeft: "8px" }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default ImgOption;
